var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path2, _path3, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashboards = function SvgDashboards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M4 6a2 2 0 0 1 2-2h32a2 2 0 0 1 2 2v25.25a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm17.25 8.125a7.124 7.124 0 1 0-14.248 0 7.124 7.124 0 0 0 14.248 0m-4 12.375a2 2 0 0 0-2 2v.5a2 2 0 0 0 2 2h1.25a2 2 0 0 0 2-2v-.5a2 2 0 0 0-2-2zM7 29.5A1.5 1.5 0 0 1 8.5 28h2.25a1.5 1.5 0 0 1 0 3H8.5A1.5 1.5 0 0 1 7 29.5m17.75-6a2 2 0 0 0-2 2V29a2 2 0 0 0 2 2H26a2 2 0 0 0 2-2v-3.5a2 2 0 0 0-2-2zm6.25-.25a2 2 0 0 1 2-2h1.25a2 2 0 0 1 2 2V29a2 2 0 0 1-2 2H33a2 2 0 0 1-2-2zm-6.75-12.5a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 0 3h-9a1.5 1.5 0 0 1-1.5-1.5m1.5 3a1.5 1.5 0 0 0 0 3h10.5a1.5 1.5 0 0 0 0-3z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 29,
    x: 43,
    y: 4,
    fill: "#FFD2A8",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 12,
    x: 43,
    y: 36,
    fill: "#B4CFFF",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 12,
    x: 26,
    y: 36,
    fill: "#FF9D43",
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 15,
    x: 26,
    y: 51,
    fill: "#2F68D1",
    rx: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 15,
    x: 53,
    y: 51,
    fill: "#FFD2A8",
    rx: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 30,
    x: 4,
    y: 36,
    fill: "#6C9BF1",
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C9BF1",
    d: "M21.25 14.125A7.124 7.124 0 0 0 14.125 7v7.125z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4CFFF",
    d: "M9.087 19.163a7.125 7.125 0 0 0 12.163-5.038h-7.125z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 5.25,
    height: 3,
    x: 7,
    y: 28,
    fill: "#B4CFFF",
    rx: 1.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 5.25,
    height: 7.5,
    x: 22.75,
    y: 23.5,
    fill: "#6C9BF1",
    rx: 2
  })));
};
export default SvgDashboards;